import { AutogenLayoutMarketingPlanList } from "./autogen/AutogenLayoutMarketingPlanList";

export class MarketingPlanList extends AutogenLayoutMarketingPlanList {

    onLoad(): void | Promise<void> {
        this.tableMarketingPlan.addButtonCaption = "Add Marketing Plan";
    }

}